// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Steps-module--fadeInAnimation--257c4";
export var step = "Steps-module--step--4f57a";
export var stepTitle = "Steps-module--stepTitle--bcf1d";
export var title = "Steps-module--title--4ddba";
export var wrapper = "Steps-module--wrapper--0430f";